<template>
  <div :class="$style.ctn">
    <PaginationTable
      :class="$style.table"
      :head="synchronizationHead"
      :values="synchronization"
      :pagination-detach="true"
    >
      <template #cell="{ cell, i }">
        <b v-if="synchronizationHead[i].isBold">{{ cell }}</b>
        <div v-else-if="synchronizationHead[i].isBadge" :class="$style.badge">
          <Badge :full-width="true" :type="cell.type" :value="cell.value" />
        </div>
      </template>
    </PaginationTable>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import Badge from './Badge.vue';
import PaginationTable from './PaginationTable.vue';

export default defineComponent({
  components: { Badge, PaginationTable },
  inject: ['root'],
  data: () => ({
    synchronizationHead: [
      { value: 'PID', width: 58, isBold: true },
      { value: 'Process', width: 170 },
      { value: 'Opertaion', width: 86, isBadge: true },
      { value: 'Type', width: 60 },
      { value: 'Name', width: 418, isBold: true },
      { value: 'Status', width: 287 },
    ],
  }),
  computed: {
    synchronization() {
      return this.root.synchronization.values;
    },
  },
});
</script>

<style lang="scss" module>
.ctn {
  padding-top: 20px;
}
.badge {
  display: inline-block;
  width: 100%;
  padding-right: 15px;
}
.table {
  --padding-left-right: 14px;
}
</style>
